import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { ladles24hReducer } from "@/pages/ladle-track/ladle-24h-log/reducers/ladles-24h.reducer";
import { LadlesReducer } from "@/pages/ladle-track/ladle-overview/reducers/ladles.reducer";
import { locationSelectedReducer } from "@/pages/ladle-track/plant-overview/reducers/location-selected.reducer";
import { changeRootLocationReducer } from "@/pages/ladle-track/plant-overview/reducers/plant-overview/change-root-location.reducer";
import { PlantOverviewReducer } from "@/pages/ladle-track/plant-overview/reducers/plant-overview/plant-overview.reducer";
import { commonReducer } from "./common/common.reducer";
import { HeatsReducer } from "./heats/heats.reducer";

export const store = configureStore({
	reducer: {
		plantOverview: PlantOverviewReducer.reducer,
		locationSelected: locationSelectedReducer.reducer,
		changeRootLocation: changeRootLocationReducer.reducer,
		ladleOverview: LadlesReducer.reducer,
		common: commonReducer.reducer,
		heats: HeatsReducer.reducer,
		ladles24h: ladles24hReducer.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
